/**
 * Data Version Configuration
 * 
 * IMPORTANT: Increment this version number whenever you update CSV files in Supabase.
 * This will automatically invalidate cached data in users' browsers and force a fresh download.
 * 
 * How to use:
 * 1. Update your CSV files in Supabase Storage
 * 2. Increment the version number below (e.g., from 1 to 2)
 * 3. Deploy your changes
 * 4. Users will automatically get the new data on their next visit
 */

export const DATA_VERSION = 2;

// Optional: Track version history for debugging
export const VERSION_HISTORY = [
    { version: 1, date: '2026-01-26', description: 'Initial data version' },
    { version: 2, date: '2026-02-08', description: 'Force refresh for content updates' }
];
